// Which volunteer a visitor said they are, per event and in this browser only. Volunteers have no accounts:
// this is what lets the event's page greet them with their next shifts. Nothing of it reaches the server.
//
// Every access is wrapped: localStorage throws in a private window with site data blocked, and the page must
// work without it, as if nobody had been remembered.

const KEY = 'eventVolunteer'

function keyOf(eventId) {
  return `${KEY}:${eventId}`
}

export function readRememberedVolunteer(eventId) {
  try {
    const volunteer = JSON.parse(window.localStorage.getItem(keyOf(eventId)))
    return Number.isInteger(volunteer?.id) ? { id: volunteer.id, name: String(volunteer.name ?? '') } : null
  } catch {
    return null
  }
}

export function rememberVolunteer(eventId, { id, name }) {
  try {
    window.localStorage.setItem(keyOf(eventId), JSON.stringify({ id, name }))
    return true
  } catch {
    return false
  }
}

export function forgetVolunteer(eventId) {
  try {
    window.localStorage.removeItem(keyOf(eventId))
  } catch {
    // Nothing remembered that could be forgotten
  }
}
